import {jwtDecode} from 'jwt-decode';

interface DecodedToken {
  exp?: number;
  role?: string[];
  [key: string]: unknown;
}

export class TokenUtils {
  static isTokenValid(token: string): boolean {
    if (!token || token.trim() === '') {
      return false;
    }

    try {
      const decoded: DecodedToken = jwtDecode<DecodedToken>(token);

      if (decoded.exp) {
        const expirationDate = new Date(decoded.exp * 1000);
        const now = new Date();

        if (now > expirationDate) {
          return false;
        }
      }

      return true;
    } catch {
      return false;
    }
  }

  static getUserRole(token: string): string[] {
    if (!token || token.trim() === '') {
      return [];
    }

    try {
      const decoded: DecodedToken = jwtDecode<DecodedToken>(token);

      return decoded.role ?? [];
    } catch {
      return [];
    }
  }
}
